import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { DesignToken, Heading, SpacingToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

interface IHeader {
  component: ReactNode;
  id: string;
}
interface IProps {
  header: IHeader;
  children: ReactNode;
}

export const AgentFormSection: FC<IProps> = ({ header, children }) => {
  return (
    <ResponsiveContainer column gap={withVar(SpacingToken.Spacing4)}>
      <FlexHeading id={header.id} size="xs">
        {header.component}
      </FlexHeading>
      <Block>{children}</Block>
    </ResponsiveContainer>
  );
};

const FlexHeading = styled(Heading)`
  display: flex;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing2)};

  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  padding-block: ${withVar(SpacingToken.Spacing1)};
  scroll-margin-top: ${withVar(SpacingToken.Spacing4)};
`;

const ResponsiveContainer = styled(Flex)`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    margin-inline: ${withVar(SpacingToken.Spacing4)};
  }
`;
